import module from 'finanzas/module.js'
import template from './template.html'
import {isDate} from 'angular'

export class CargaMovimientosBancariosHistorialListaComponent {
  fecha
  data

  constructor (FinancesCargarMovimientosBancariosHistorial) {
    this.FinancesCargarMovimientosBancariosHistorialService = FinancesCargarMovimientosBancariosHistorial
  }

  $onChanges (changes) {
    if (changes.fecha) {
      this.data = null

      if (isDate(this.fecha)) this.cargarHistorial()
    }
  }

  cargarHistorial () {
    this.promise = this.FinancesCargarMovimientosBancariosHistorialService.get(this.fecha)
      .then((response) => (this.data = response.data))
  }

  eliminar (data) {
    this.data = this.data.filter((item) => item.id_lote !== data.id_lote)
  }
}

module.component('financesCargamovimientosbancariosHistorialLista', {
  controller: CargaMovimientosBancariosHistorialListaComponent,
  template,
  bindings: {
    fecha: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/historial/lista/component.js